import React from 'react';
import { pillars } from '../../data/pillars';
export function PillarsSection() {
  return <section aria-label="Nos engagements" className="w-full border-y border-ink/10 bg-cream" data-id="element-57" data-mp="yp0fbtinx1qw">
      <ul className="mx-auto grid max-w-7xl divide-y divide-ink/10 px-5 md:grid-cols-3 md:divide-x md:divide-y-0 md:px-8" data-id="element-58" data-mp="tpxaa92omvix">
        {pillars.map(pillar => <li key={pillar.title} className="py-10 md:px-8 md:py-14 md:first:pl-0 md:last:pr-0" data-id="element-59" data-mp="pqy9n0nzhkxa">
            <h2 className="font-serif text-3xl leading-tight text-aloe-900" data-id="element-60" data-mp="1mh8lofi0jugl">{pillar.title}</h2>
            <p className="mt-3 max-w-sm leading-relaxed text-ink/70" data-id="element-61" data-mp="1hgt7xmttkky3">{pillar.text}</p>
          </li>)}
      </ul>
    </section>;
}